import React from 'react';

interface ITab {
  label: string;
  isActive: boolean;
  disabled?: boolean;
  setActiveTab: () => void;
  setTabIndex: () => void;
}

export const Tab = React.forwardRef<HTMLElement, ITab>(
  ({ label, isActive, disabled, setActiveTab, setTabIndex }, ref) => {
    let color = isActive ? '#2B2D3B' : '#6057D3';
    if (disabled) {
      color = 'grey';
    }

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <span
        ref={ref}
        onClick={() => {
          if (!disabled) {
            setActiveTab();
            setTabIndex();
          }
        }}
        style={{
          padding: '1em',
          color,
          fontSize: '18px',
          lineHeight: '26px',
          fontFamily: 'Inter',
          cursor: 'pointer'
        }}
      >
        {label}
      </span>
    );
  }
);
